import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A6PdfPageSelectionEdit } from "./edit";
import { A6PdfPageSelectionNew } from "./new";
import { A6PdfPageSelectionTable } from "./table";

export default function A6PdfPageSelection() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_s_lection_de_pages_pdf", {
        ns: "titles",
        defaultValue: "Quantilia | PDF Page Selection",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route path=":id" element={<A6PdfPageSelectionEdit />} />
      <Route index element={<A6PdfPageSelectionTable />} />
      <Route path="/new" element={<A6PdfPageSelectionNew />} />
    </Routes>
  );
}
